<!--详情页面-->
<template>
  <el-dialog
    title="打印信息"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <el-table
      :data="printData"
      :height="tableHeight(81)"
      size="mini"
      stripe
      border
      style="width: 100%;"
    >
      <el-table-column
        type="index"
        width="60"
        label="序号"
        align="center">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="erpserial"-->
        <!--label="订单号"-->
        <!--align="center"-->
        <!--header-align="center"-->
        <!--width="120"-->
      <!--&gt;-->
      <!--</el-table-column>-->
      <el-table-column
        prop="adddate"
        label="打印时间"
        align="center"
        header-align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="姓名"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="dname"
        label="部门"
        align="left"
        header-align="center"
      >
      </el-table-column>

    </el-table>
  </el-dialog>
</template>


<script>
  import {list} from '@/api/order/printlog';

  export default {
    name: 'wwrt',
    data() {
      return {
        dialogSeeVisible: false,
        printData: [],//打印日志
      }
    },
    methods: {

      show() {
        this.dialogSeeVisible = true;
      },
      initData(erpserial) {
        list({erpserial: erpserial}).then(response => {
          if (response.data.obj)
            this.printData = response.data.obj.rows

        })
      }

    },
    mounted() {

    },
    components: {}

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/printlogList.vue